import {RumInitConfiguration} from '@datadog/browser-rum';
import {angularPlugin} from '@datadog/browser-rum-angular';
import {environment} from '../../environments/environment';
// eslint-disable-next-line @nx/enforce-module-boundaries
import packageJson from '../../../../../package.json';

const PRODUCTION_SESSION_SAMPLE_RATE = 20;
const NON_PRODUCTION_SESSION_SAMPLE_RATE = 100;
const PRODUCTION_SESSION_REPLAY_SAMPLE_RATE = 0;
const NON_PRODUCTION_SESSION_REPLAY_SAMPLE_RATE = 0;

/**
 * Datadog RUM configuration for Product Management UI.
 */
export function buildDatadogRumConfig(): RumInitConfiguration {
  return {
    applicationId: '306c40f3-8c62-4800-afe7-6a85c4d035fe',
    clientToken: 'pub9d31b0e48c55ee33dcbb49be123413a2',
    site: 'datadoghq.com',
    service: 'product-management-ui',
    env: environment.env,
    version: packageJson.version,
    sessionSampleRate: getSessionSampleRate(),
    sessionReplaySampleRate: getSessionReplaySampleRate(),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    trackSessionAcrossSubdomains: true,
    plugins: [angularPlugin({router: true})],
  };
}

function getSessionSampleRate(): number {
  if (!environment.enableDatadogRum) {
    return 0;
  }

  return environment.production ? PRODUCTION_SESSION_SAMPLE_RATE : NON_PRODUCTION_SESSION_SAMPLE_RATE;
}

function getSessionReplaySampleRate(): number {
  if (!environment.enableDatadogRum) {
    return 0;
  }

  return environment.production ? PRODUCTION_SESSION_REPLAY_SAMPLE_RATE : NON_PRODUCTION_SESSION_REPLAY_SAMPLE_RATE;
}
